'use client';

import { DotLottieReact } from '@lottiefiles/dotlottie-react';
interface Props {
  src: string;
  width: number;
  height: number;
  className?: string;
}
const LottieViewer = ({
  src,
  className,
  width,
  height
}: Props) => {
  return <DotLottieReact src={src} className={className} autoplay loop width={width} height={height} data-sentry-element="DotLottieReact" data-sentry-component="LottieViewer" data-sentry-source-file="index.tsx" />;
};
export default LottieViewer;